import React, { useState, useEffect } from 'react';
import useSortableData from '../hooks/useSortableData';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import Loader from "../components/Loader/Loader";
import DateRangePicker from '../components/DateRangePicker';
import apiRequester from '../utils/apiClient';

function TemplateWiseReport() {

    const baseUrl = process.env.REACT_APP_API_BASE_URL;

    // const [selectedContainer, setSelectedContainer] = useState('container1');

    const [container1Checkboxes, setContainer1Checkboxes] = useState({
        row1: false,
        row2: false,
    });
    const [loading, setLoading] = useState(false);

    const [container1Months, setContainer1Months] = useState({
        row1: [],
        row2: [],
    });

    const [container1Years, setContainer1Years] = useState({
        row1: '',
        row2: '',
    });
    const [templateData, setTemplateData] = useState([]);
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const [mobileNumber, setMobileNumber] = useState('');
    const [templateId, setTemplateId] = useState('');
    const [error, setError] = useState('');

    // const [container2Checkbox, setContainer2Checkbox] = useState(false);
    const [openDropdowns, setOpenDropdowns] = useState({});

    const [reportType, setReportType] = useState('monthwise');

    // const [reportTypeOpen, setReportTypeOpen] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const formatDate = (date) => {
        if (!date) return "";

        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");

        return `${year}-${month}-${day}`;
    };


    const months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
    ];

    const years = ['2026', '2025'];

    const PageNo = [10, 20, 50, 100];

    // month name => month number
    const monthMap = {
        January: 1,
        February: 2,
        March: 3,
        April: 4,
        May: 5,
        June: 6,
        July: 7,
        August: 8,
        September: 9,
        October: 10,
        November: 11,
        December: 12,
    };

    const handleShow = async () => {
        try {
            if (!fromDate || !toDate) {
                setError('Please select both dates');
                return;
            }

            setLoading(true);
            setError('');

            const params = new URLSearchParams();
            params.append('UsedInMonth', '');
            params.append('UsedInYear', '');
            params.append('NotUsedInMonth', '');
            params.append('NotUsedInYear', '');
            params.append('CurrentDate', true);
            params.append('FromDate', formatDate(fromDate));
            params.append('ToDate', formatDate(toDate));
            params.append('TemplateID', templateId);

            if (mobileNumber) params.append('MobNo', mobileNumber);

            const response = await apiRequester('GET', `Report/GetTemplateInfo?${params.toString()}`);

            setTemplateData(Array.isArray(response) ? response : []);

        } catch (err) {
            setError(err?.response?.data?.message || 'Failed to fetch data');
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const handlePageSizeChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    const handleSearchChange = (e) => {
        setSearchText(e.target.value);
        setCurrentPage(1);
    };

    const handlePageChange = (page) => {
        setCurrentPage(Math.min(Math.max(page, 1), totalPages));
    };

    const filteredData = templateData.filter((item) => {
        const search = searchText.toLowerCase();

        return (
            item.MONTH?.toString().toLowerCase().includes(search) ||
            item.YEAR?.toString().toLowerCase().includes(search) ||
            item.TEMPLATENAME?.toLowerCase().includes(search) ||
            item.TEMPLATEID?.toString().toLowerCase().includes(search) ||
            item.TEMPLATETEXT?.toLowerCase().includes(search)
        );
    });

    const { sortedData, sortConfig, requestSort } = useSortableData(filteredData);

    useEffect(() => {
        const handleClickOutside = (event) => {
            const openIds = Object.keys(openDropdowns).filter(id => openDropdowns[id]);
            if (openIds.length === 0) return;

            const toClose = {};

            openIds.forEach((id) => {
                const dropdownEl = document.getElementById(id);
                if (dropdownEl && !dropdownEl.contains(event.target)) {
                    toClose[id] = false;
                }
            });

            if (Object.keys(toClose).length) {
                setOpenDropdowns(prev => ({ ...prev, ...toClose }));
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [openDropdowns]);

    const totalPages = Math.max(1, Math.ceil(sortedData.length / itemsPerPage));

    const paginatedData = sortedData.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );



    useEffect(() => {
        setCurrentPage(1);
    }, [templateData, searchText, itemsPerPage]);

    const toggleContainer1Checkbox = (row) => {
        setContainer1Checkboxes((prev) => ({
            ...prev,
            [row]: !prev[row],
        }));
    };

    const toggleContainer1Month = (row, month) => {
        setContainer1Months((prev) => ({
            ...prev,
            [row]: prev[row].includes(month)
                ? prev[row].filter((m) => m !== month)
                : [...prev[row], month],
        }));
    };


    const fetchTemplateInfo = async () => {
        try {
            setLoading(true);
            setTemplateData([]);
            setCurrentPage(1);

            if (reportType === 'currentDate') {
                // Daywise request: CurrentDate=1, include FromDate/ToDate and TemplateId, leave month/year fields empty
                const params = new URLSearchParams();
                params.append('UsedInMonth', '');
                params.append('UsedInYear', '');
                params.append('NotUsedInMonth', '');
                params.append('NotUsedInYear', '');
                if (mobileNumber) params.append('MobNo', mobileNumber);
                params.append('CurrentDate', true);
                if (fromDate) params.append('FromDate', formatDate(fromDate));
                if (toDate) params.append('ToDate', formatDate(toDate));
                params.append('TemplateID', templateId);


                const response = await apiRequester('GET', `Report/GetTemplateInfo?${params.toString()}`);

                setTemplateData(response.data);

                return;
            }

            const UsedInMonth = container1Months.row1
                .map((month) => monthMap[month])
                .join(',');

            const NotUsedInMonth = container1Months.row2
                .map((month) => monthMap[month])
                .join(',');

            const UsedInYear = container1Years.row1;
            const NotUsedInYear = container1Years.row2;


            const queryParams = new URLSearchParams({
                UsedInMonth,
                UsedInYear,
                NotUsedInMonth,
                NotUsedInYear,
                CurrentDate: false,
                FromDate: '',
                ToDate: '',
                TemplateID: '',
            });

            const response = await apiRequester('GET', `Report/GetTemplateInfo?${queryParams.toString()}`);

            setTemplateData(Array.isArray(response) ? response : []);

        } catch (error) {
            console.error('API Error:', error);
        }
        finally {
            setLoading(false);
        }
    };

    const escapeCSV = (value) => {
        if (value === null || value === undefined) return "";
        const str = value.toString();
        const escaped = str.replace(/"/g, '""');
        if (str.includes(",") || str.includes("\n") || str.includes('"')) {
            return `"${escaped}"`;
        }
        return escaped;
    };

    const downloadCSV = () => {
        const data = filteredData.length ? filteredData : templateData;

        if (!data.length) {
            alert("No data available to download");
            return;
        }

        const headers = [
            "Month",
            "Year",
            "Template Name",
            "Template ID",
            "Submitted",
            "Delivered",
            "Failed",
            "Template Text"
        ];

        const rows = data.map(item => [
            escapeCSV(item.MONTH),
            escapeCSV(item.YEAR),
            escapeCSV(item.TEMPLATENAME),
            escapeCSV(item.TEMPLATEID),
            escapeCSV(item.SUBMITTED),
            escapeCSV(item.DELIVERED),
            escapeCSV(item.FAILED),
            escapeCSV(item.TEMPLATETEXT)
        ]);

        const csvContent = [
            headers.join(","),
            ...rows.map(row => row.join(","))
        ].join("\n");

        const blob = new Blob([csvContent], {
            type: "text/csv;charset=utf-8;"
        });

        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "template_report.csv");

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    const MultiSelectDropdown = ({
        row,
        selected,
        onChange,
        disabled = false,
    }) => {

        const dropdownId = `dropdown-${row}`;

        const isOpen = !!openDropdowns[dropdownId] && !disabled;

        return (
            <div className="relative">
                <button
                    type="button"
                    disabled={disabled}
                    onClick={() =>
                        !disabled &&
                        setOpenDropdowns(prev => ({ ...prev, [dropdownId]: !prev[dropdownId] }))
                    }
                    className={`w-full border border-slate-200 px-3 py-2 text-sm outline-none transition text-left flex items-center justify-between rounded ${disabled
                        ? 'bg-slate-100 text-slate-400 cursor-not-allowed'
                        : 'bg-slate-50 text-slate-700 focus:border-cyan-500 focus:ring-2 focus:ring-cyan-100'
                        }`}
                >
                    <span className="truncate">
                        {selected.length === 0
                            ? "Select Months"
                            : selected.length <= 2
                                ? selected.join(", ")
                                : `${selected.slice(0, 2).join(", ")} +${selected.length - 2} more`
                        }
                    </span>

                    <span className="text-xs">▼</span>
                </button>

                {isOpen && !disabled && (
                    <div id={dropdownId} className="absolute top-full left-0 right-0 mt-1 bg-white border border-slate-200 rounded shadow-lg z-50">
                        <div className="max-h-64 overflow-y-auto p-2 space-y-1">
                            {months.map((month) => (
                                <label
                                    key={month}
                                    className="flex items-center gap-2 px-3 py-2 hover:bg-slate-100 cursor-pointer rounded"
                                >
                                    <input
                                        type="checkbox"
                                        checked={selected.includes(month)}
                                        onChange={() => onChange(month)}
                                        className="w-4 h-4"
                                    />

                                    <span className="text-sm text-slate-700">
                                        {month}
                                    </span>
                                </label>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        );
    };

    return (
        <div className="min-h-screen bg-slate-100 text-slate-900">

            <div className="flex min-h-screen">

                <Sidebar />

                <div className="flex-1">

                    <Topbar />

                    {loading && <Loader />}

                    <main className="p-6 md:p-8">



                        <div className="border border-slate-200 bg-white/95 px-4 py-6 shadow-[0_20px_60px_-30px_rgba(15,23,42,0.25)] backdrop-blur-sm rounded-lg">

                            <div className="mb-3 flex items-center gap-1">

                                <span className="text-sm text-bold font-medium text-slate-700">
                                    Report Type :
                                </span>

                                <label className="flex items-center gap-2">
                                    <input
                                        type="radio"
                                        name="reportType"
                                        value="monthwise"
                                        checked={reportType === 'monthwise'}
                                        onChange={() => setReportType('monthwise')}
                                        className="w-4 h-4"
                                    />
                                    <span className="text-xs font-medium text-slate-600">Monthly</span>
                                </label>

                                <label className="flex items-center gap-2">
                                    <input
                                        type="radio"
                                        name="reportType"
                                        value="currentDate"
                                        checked={reportType === 'currentDate'}
                                        onChange={() => setReportType('currentDate')}
                                        className="w-4 h-4"
                                    />
                                    <span className="text-xs font-medium text-slate-600">Day Wise</span>
                                </label>
                            </div>
                            {/* Monthly SECTION */}
                            {reportType === 'monthwise' && (
                                <>
                                    <div className=" overflow-visible gap-4">

                                        {/* ROW 1 */}
                                        <div className="flex gap-4 items-center mb-2 ">

                                            <div className="flex items-center gap-2 justify-center">

                                                <input
                                                    type="checkbox"
                                                    checked={container1Checkboxes.row1}
                                                    onChange={() =>
                                                        toggleContainer1Checkbox('row1')
                                                    }
                                                    className="w-4 h-4"
                                                />

                                                <span className="text-sm font-medium text-slate-600 space-y-4">
                                                    Template Used in
                                                </span>

                                            </div>

                                            {/* MONTH */}
                                            <div className="w-48 overflow-visible">
                                                <MultiSelectDropdown
                                                    row="row1"

                                                    selected={container1Months.row1}
                                                    onChange={(month) =>
                                                        toggleContainer1Month('row1', month)
                                                    }
                                                />

                                            </div>

                                            {/* YEAR */}
                                            <div className="w-32">



                                                <select
                                                    value={container1Years.row1}
                                                    onChange={(e) =>
                                                        setContainer1Years((prev) => ({
                                                            ...prev,
                                                            row1: e.target.value,
                                                        }))
                                                    }
                                                    className="w-full border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-cyan-500 focus:ring-2 focus:ring-cyan-100 rounded"
                                                >
                                                    <option value="">
                                                        Select Year
                                                    </option>

                                                    {years.map((year) => (
                                                        <option
                                                            key={year}
                                                            value={year}
                                                        >
                                                            {year}
                                                        </option>
                                                    ))}

                                                </select>

                                            </div>
                                        </div>

                                        {/* ROW 2 */}
                                        <div className="flex gap-4 items-center justify-between">
                                            <div
                                                className={`flex gap-2 items-center ${!container1Checkboxes.row1
                                                    ? 'opacity-50 pointer-events-none'
                                                    : ''
                                                    }`}
                                            >

                                                <div className="flex items-center gap-2 ">

                                                    <input
                                                        type="checkbox"
                                                        checked={container1Checkboxes.row2}
                                                        onChange={() =>
                                                            toggleContainer1Checkbox('row2')
                                                        }
                                                        disabled={!container1Checkboxes.row1}
                                                        className="w-4 h-4 disabled:cursor-not-allowed"
                                                    />

                                                    <span className="text-sm font-medium text-slate-600">
                                                        Template not Used in
                                                    </span>

                                                </div>

                                                {/* MONTH */}
                                                <div className="w-48 overflow-visible">



                                                    <MultiSelectDropdown
                                                        row="row2"
                                                        selected={container1Months.row2}
                                                        onChange={(month) =>
                                                            toggleContainer1Month('row2', month)
                                                        }
                                                        disabled={!container1Checkboxes.row1}
                                                    />

                                                </div>

                                                {/* YEAR */}
                                                <div className="w-32">



                                                    <select
                                                        value={container1Years.row2}
                                                        onChange={(e) =>
                                                            setContainer1Years((prev) => ({
                                                                ...prev,
                                                                row2: e.target.value,
                                                            }))
                                                        }
                                                        disabled={!container1Checkboxes.row1}
                                                        className="w-full border border-slate-200 px-3 py-2 text-sm outline-none transition disabled:bg-slate-100 disabled:text-slate-400 disabled:cursor-not-allowed bg-slate-50 text-slate-700 focus:border-cyan-500 focus:ring-2 focus:ring-cyan-100 rounded"
                                                    >

                                                        <option value="">
                                                            Select Year
                                                        </option>

                                                        {years.map((year) => (
                                                            <option
                                                                key={year}
                                                                value={year}
                                                            >
                                                                {year}
                                                            </option>
                                                        ))}

                                                    </select>

                                                </div>





                                            </div>


                                            <div className="flex gap-2 items-center justify-end">
                                                <button
                                                    type="button"
                                                    onClick={fetchTemplateInfo}
                                                    disabled={loading}
                                                    className="rounded bg-slate-700 px-6 py-2 text-sm font-semibold text-white transition hover:bg-blue-700 disabled:opacity-50"
                                                >
                                                    {loading ? 'Loading...' : 'Show Report'}
                                                </button>
                                                <button className='rounded bg-slate-700 px-6 py-2 text-sm font-semibold text-white transition hover:bg-blue-700 disabled:opacity-50' onClick={() => window.location.reload()}>
                                                    Reset
                                                </button>
                                            </div>

                                        </div>

                                    </div>
                                </>
                            )}

                            {/* CURRENT DATE SECTION */}
                            {reportType === 'currentDate' && (



                                <div className="rounded-lg  bg-white/95 shadow-[0_20px_60px_-30px_rgba(15,23,42,0.25)] backdrop-blur-sm">
                                    <div className="grid gap-4 md:grid-cols-[1fr_1fr_auto_auto] md:items-end">
                                        <label className="block">
                                            <span className="text-xs font-medium text-slate-600">Template ID</span>
                                            <input
                                                type="text"
                                                value={templateId}
                                                onChange={(e) => setTemplateId(e.target.value)}
                                                placeholder="Enter template id"
                                                className="text-sm mt-2 w-full border border-slate-200 bg-slate-50 px-3 py-2 text-slate-700 outline-none transition focus:border-cyan-500 focus:ring-2 focus:ring-cyan-100"
                                            />
                                        </label>

                                        <label className="block flex flex-col">
                                            <span className="text-xs font-medium text-slate-600">
                                                Date Range
                                            </span>
                                            <DateRangePicker
                                                value={{ fromDate, toDate }}
                                                onChange={({ fromDate: f, toDate: t }) => {
                                                    setFromDate(f);
                                                    setToDate(t);
                                                }}
                                                placeholder="DD-MM-YYYY ~  DD-MM-YYYY"
                                                displayFormat="DD-MM-YYYY"
                                                classNames="text-sm mt-2 w-full border border-slate-200 bg-slate-50 px-3 py-1 text-slate-700 outline-none transition focus:border-cyan-500 focus:ring-2 focus:ring-cyan-100"
                                                showFooter={true}
                                                configs={{ footer: { cancel: 'Cancel', apply: 'Apply' } }}
                                            />
                                        </label>

                                        <button
                                            type="button"
                                            onClick={handleShow}
                                            disabled={loading}
                                            className="rounded bg-slate-700 px-6 py-2 text-sm font-semibold text-white transition hover:bg-blue-700 disabled:opacity-50"
                                        >
                                            {loading ? 'Loading...' : 'Show'}
                                        </button>
                                        <button className='rounded bg-slate-700 px-6 py-2 text-sm font-semibold text-white transition hover:bg-blue-700 disabled:opacity-50' onClick={() => window.location.reload()}>
                                            Reset
                                        </button>
                                    </div>

                                    {error && (
                                        <div className="mt-4 text-sm text-red-600">
                                            {error}
                                        </div>
                                    )}
                                </div>
                            )}

                        </div>
                        {paginatedData.length > 0 && (
                            <div className="border border-slate-200 bg-white/95 px-2 sm:px-4 py-4 sm:py-6 shadow-[0_20px_60px_-30px_rgba(15,23,42,0.25)] backdrop-blur-sm rounded-lg">

                                <div className="mb-3 flex items-center gap-4 justify-between">
                                    <div className="flex items-center gap-2">
                                        <select
                                            value={itemsPerPage}
                                            onChange={handlePageSizeChange}
                                            className="w-[80px] border border-slate-200 bg-slate-50 px-3 py-2 text-sm rounded"
                                        >
                                            {PageNo.map((pageNo) => (
                                                <option key={pageNo} value={pageNo}>
                                                    {pageNo}
                                                </option>
                                            ))}
                                        </select>

                                        <span className="text-sm text-slate-600">
                                            TOTAL RECORD : {templateData.length}
                                        </span>
                                    </div>
                                    <input
                                        type="text"
                                        value={searchText}
                                        onChange={handleSearchChange}
                                        placeholder="Search Here"
                                        className="text-sm w-150 border border-slate-200 bg-slate-50 px-3 py-2 rounded focus:border-cyan-500 focus:ring-2 focus:ring-cyan-100"
                                    />
                                </div>

                                {/* scroll wrapper */}
                                <div className="overflow-auto max-h-[250px] mt-3">

                                    <table className="w-full min-w-[600px] table-fixed border border-slate-200 bg-white text-xs">

                                        <thead className="bg-slate-100 sticky top-0 z-10">
                                            <tr>
                                                <th className="border px-1 py-2 w-[50px]">S.No</th>
                                                <th onClick={() => requestSort('MONTH')} className="border px-1 py-2 w-[60px] cursor-pointer select-none">Month{sortConfig.key === 'MONTH' ? (sortConfig.direction === 'ascending' ? ' ↑' : ' ↓') : ''}</th>
                                                <th onClick={() => requestSort('YEAR')} className="border px-1 py-2 w-[60px] cursor-pointer select-none">Year{sortConfig.key === 'YEAR' ? (sortConfig.direction === 'ascending' ? ' ↑' : ' ↓') : ''}</th>
                                                <th onClick={() => requestSort('TEMPLATENAME')} className="border px-1 py-2 w-[180px] cursor-pointer select-none">Template Name{sortConfig.key === 'TEMPLATENAME' ? (sortConfig.direction === 'ascending' ? ' ↑' : ' ↓') : ''}</th>
                                                <th onClick={() => requestSort('TEMPLATEID')} className="border px-1 py-2 w-[140px] cursor-pointer select-none">Template ID{sortConfig.key === 'TEMPLATEID' ? (sortConfig.direction === 'ascending' ? ' ↑' : ' ↓') : ''}</th>
                                                <th onClick={() => requestSort('SUBMITTED')} className="border px-1 py-2 w-[80px] cursor-pointer select-none">Submitted{sortConfig.key === 'SUBMITTED' ? (sortConfig.direction === 'ascending' ? ' ↑' : ' ↓') : ''}</th>
                                                <th onClick={() => requestSort('DELIVERED')} className="border px-1 py-2 w-[80px] cursor-pointer select-none">Delivered{sortConfig.key === 'DELIVERED' ? (sortConfig.direction === 'ascending' ? ' ↑' : ' ↓') : ''}</th>
                                                <th onClick={() => requestSort('FAILED')} className="border px-1 py-2 w-[70px] cursor-pointer select-none">Failed{sortConfig.key === 'FAILED' ? (sortConfig.direction === 'ascending' ? ' ↑' : ' ↓') : ''}</th>
                                                <th onClick={() => requestSort('TEMPLATETEXT')} className="border px-1 py-2 w-[300px] cursor-pointer select-none">Template Text{sortConfig.key === 'TEMPLATETEXT' ? (sortConfig.direction === 'ascending' ? ' ↑' : ' ↓') : ''}</th>
                                            </tr>
                                        </thead>

                                        <tbody key={currentPage}>
                                            {paginatedData.map((item, index) => (
                                                <tr key={index} className="hover:bg-slate-50">
                                                    <td className="border px-1 py-1 text-center">
                                                        {(currentPage - 1) * itemsPerPage + index + 1}
                                                    </td>

                                                    <td className="border px-1 py-1 text-center">{item.MONTH}</td>
                                                    <td className="border px-1 py-1 text-center">{item.YEAR}</td>

                                                    <td className="border px-1 py-1 w-[180px]">
                                                        <div className="truncate">{item.TEMPLATENAME}</div>
                                                    </td>

                                                    <td className="border px-1 py-1 text-center">{item.TEMPLATEID}</td>
                                                    <td className="border px-1 py-1 text-center">{item.SUBMITTED}</td>
                                                    <td className="border px-1 py-1 text-center">{item.DELIVERED}</td>
                                                    <td className="border px-1 py-1 text-center">{item.FAILED}</td>

                                                    <td className="border px-1 py-1 break-words whitespace-pre-wrap">
                                                        {item.TEMPLATETEXT}
                                                    </td>

                                                </tr>
                                            ))}
                                        </tbody>

                                    </table>
                                </div>


                                <div className="mt-4 flex items-center justify-between gap-4 flex-wrap">
                                    {/* Simple Pagination */}
                                    <div className="flex items-center gap-3 ">

                                        {/* Prev */}
                                        <button
                                            onClick={() => handlePageChange(currentPage - 1)}
                                            disabled={currentPage === 1}
                                            className="px-3 py-1 border rounded disabled:opacity-50"
                                        >
                                            ←
                                        </button>

                                        {/* Current Page */}
                                        <span className="px-3 py-1 border rounded bg-cyan-500 text-white">
                                            {currentPage}
                                        </span>

                                        {/* Next */}
                                        <button
                                            onClick={() => handlePageChange(currentPage + 1)}
                                            disabled={currentPage === totalPages}
                                            className="px-3 py-1 border rounded disabled:opacity-50"
                                        >
                                            →
                                        </button>

                                        <span className="text-sm text-slate-600">
                                            {currentPage} of {totalPages}
                                        </span>

                                    </div>
                                    <button
                                        onClick={downloadCSV}
                                        className="px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded"
                                    >
                                        Download CSV
                                    </button>
                                </div>
                            </div>
                        )}

                    </main>
                </div>
            </div>
        </div>
    );
}

export default TemplateWiseReport;